exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.adjust-bill-form-dialog .el-dialog__body{\r\n  padding-top: 5px;\r\n  padding-bottom: 10px;\n}\r\n", ""]);

// exports
